import { CommonModule, DatePipe } from '@angular/common';
import { Component, inject, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormsModule } from '@angular/forms';
import { NgbNavModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { PayrollsService } from '@services/payrolls.service';
import { ReportService } from '@services/report.service';
import { NumberPipe } from 'app/pipes/number.pipe';

@Component({
  selector: 'app-review-payroll',
  standalone: true,
  imports: [CommonModule, NgbNavModule, FormsModule, NumberPipe, NgbTooltipModule],
  providers: [PayrollsService, ReportService],
  templateUrl: './review-payroll.component.html',
  styleUrls: ['./review-payroll.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ReviewPayrollComponent {

  @Input() contractSel: any


}
